<template>
  <div class="question-content">
    <div v-if="fullScreenLoading" class="loading">
      <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="30"
        :color="theme.themeColor.split(';')[0]" />
    </div>
    <div class="main-content" :class="{ 'box-full-screen': isFull }">
      <div class="inner-header">
        <span class="type-name">
          {{ formateType(question.typeId, question.questionType) }}
          <span class="score">（{{ question.score || 0 }}分）</span>
          <span v-if="isExploreQuestion" class="explore-title-tip">
            <i class="el-icon-warning"></i>
            闯关成功，自动切换至下一题
          </span>
        </span>
        <div v-if="isExploreQuestion" class="box-full-btn" @click="isFull = !isFull">
          <i class="full" v-show="!isFull"></i><span v-show="!isFull">全屏</span>
          <i class="close" v-show="isFull"></i><span v-show="isFull">退出全屏</span>
        </div>
      </div>
      <div :class="`${isExploreQuestion ? 'scroll-box-passcode' : 'scroll-box'} ${isFull ? 'box-full-screen-content' : ''
        }`" ref="scrollBox">
        <div :class="isExploreQuestion ? 'question-wrap-passcode' : 'question-wrap'">
          <!--题目内容-->
          <div v-if="!isExploreQuestion" class="question-desc question-render-container"></div>
          <!--填空题-->
          <div class="blank-wrap" v-if="question.typeId === 20">
            <textarea placeholder="请在这里输入答案" class="blank-fill" @mouseenter="(event) => areaChange(event, true)"
              @mouseleave="(event) => areaChange(event)" :style="`border-color: ${theme.lightThemeColor}`"
              v-model.trim="answerMap[question.questionId]" rows="5"></textarea>
          </div>
          <!--单项选择题-->
          <ul class="option-wrap" v-if="question.typeId === 1">
            <li class="option" @mouseenter="(event) => styleChange(event, option, question.typeId, true)
              " @mouseleave="(event) => styleChange(event, option, question.typeId)
                " v-for="(option, index) in question.choice.choices" :key="index" :style="setStateStyle(option)"
              :class="{ 'is-select': option.submit_id === answerMap[question.questionId] }"
              @click="selectOption(option.submit_id)">
              <div class="option-name-wrap" :style="option.submit_id === answerMap[question.questionId]
                ? `background-color: ${theme.themeColor}`
                : `background-color: ${theme.lightThemeColor}`
                ">
                <span>{{ order[index] }}</span>
              </div>
              <div class="option-content">
                <p class="desc">{{ option.text }}</p>
                <div v-if="option.image" class="image">
                  <el-image :src="option.image" :preview-src-list="[option.image]">
                  </el-image>
                </div>
              </div>
            </li>
          </ul>
          <!--多项选择题-->
          <ul class="option-wrap" v-if="question.typeId === 2">
            <li class="option" v-for="(option, index) in question.choice.choices" :key="option.submit_id"
              :style="setStateStyle(option)"
              :class="{ 'is-select': (answerMap[question.questionId] && answerMap[question.questionId].includes(option.submit_id)) }"
              @mouseenter="(event) => styleChange(event, option, question.typeId, true)"
              @mouseleave="(event) => styleChange(event, option, question.typeId)"
              @click="selectOption(option.submit_id)">
              <div class="option-name-wrap" :style="(answerMap[question.questionId] && answerMap[question.questionId].includes(option.submit_id))
                ? `background-color: ${theme.themeColor}`
                : `background-color: ${theme.lightThemeColor}`
                ">
                <span>{{ order[index] }}</span>
              </div>
              <div class="option-content">
                <p class="desc">{{ option.text }}</p>
                <div v-if="option.image" class="image">
                  <el-image :src="option.image" :preview-src-list="[option.image]">
                  </el-image>
                </div>
              </div>
            </li>
          </ul>
          <!--判断题-->
          <ul class="option-wrap" v-if="question.typeId === 6">
            <li class="option" @mouseenter="(event) => styleChange(event, option, question.typeId, true)
              " @mouseleave="(event) => styleChange(event, option, question.typeId)
                " v-for="(option, index) in question.yes_no.yes_no" :style="setStateStyle(option)" :key="index"
              :class="{ 'is-select': option.submit_id === answerMap[question.questionId] }"
              @click="selectOption(option.submit_id)">
              <div class="option-name-wrap" :style="option.submit_id === answerMap[question.questionId]
                ? `background-color: ${theme.themeColor}`
                : `background-color: ${theme.lightThemeColor}`
                ">
                <span>{{ order[index] }}</span>
              </div>
              <div class="option-content">
                <p class="desc">
                  {{ option.mark_yes_no === "YES" ? "对" : "错" }}
                </p>
              </div>
            </li>
          </ul>
          <!--操作题，有上传文件的python题属于新题型，不显示此栏-->
          <div :class="isExploreQuestion ? 'tool-wrap-passcode' : 'tool-wrap'" v-show="isOperateQuestion">
            <div id="iframeWrap" class="editor" :class="{ 'full-screen': isFullScreen }" v-show="isOperateQuestion">
            </div>

            <!--操作题，并且非闯关题-->
            <div v-if="isOperateQuestion && !isExploreQuestion">
              <div class="countdown" :class="{
                'py-countdown': question.questionType === 2,
                'scratch-countdown': question.questionType === 3,
                'tart-countdown': [6, 7].includes(question.questionType),
                'full-screen-position': isFullScreen,
              }" v-show="isFullScreen">
                <span class="word">剩余时间</span>
                <span class="time" v-if="endTime">{{
                  endTime | formateTime(countdown) | timeFactory
                }}</span>
              </div>
              <div v-show="!loading" class="toAnswer" @click="showFullScreen">
                全屏作答<span class="arrow"></span>
              </div>
              <div v-show="loading" class="toAnswer" style="cursor: default;">
                作品加载中，请稍后...
              </div>
            </div>
          </div>
          <!--python文件上传题-->
          <div class="new-type-wrap" v-if="question.questionType === 1">
            <button class="data-download" @click="downloadExamData(question.uploadUrl)">
              <i class="download-icon"></i>考试资料下载
            </button>
            <div class="upload-wrap">
              <p class="tip">
                请根据题目提示，打开海龟编辑器进行作答，作答完成根据要求上传答案
              </p>
              <button class="data-upload" @click="uploadFile" v-if="!answerMap[question.questionId]">
                <i class="upload-icon"></i>上传答案
              </button>
              <div class="answer-wrap" v-else>
                <i class="python-icon"></i>
                <div class="answer-info">
                  <p class="file-name">
                    {{
                      answerMap[question.questionId].split("/")[
                      answerMap[question.questionId].split("/").length - 1
                      ]
                    }}
                  </p>
                  <p class="upload-time">
                    {{
                      answerMap[question.questionId].split("/")[
                      answerMap[question.questionId].split("/").length - 2
                      ] | date("H:i")
                    }}
                    上传成功
                  </p>
                </div>
                <span class="change-btn" @click="uploadFile">修改作品</span>
              </div>
              <input type="file" style="display: none" @change="fileChange" ref="fileInput" />
            </div>
          </div>
        </div>
      </div>
      <!-- 答题区域操作按钮 -->
      <template v-if="!isFull">
        <div class="btn-wrap" v-show="!isFullScreen">
          <a class="prev" :class="!switchQuestionEnabled ? 'clickDisable' : ''"
            :style="`color: ${theme.themeColor} border: 1px solid ${theme.themeColor}`"
            @click="switchQuestionEnabled ? changeQuestion('prevQuestion') : null" v-show="!isFirst">上一题</a>
          <a class="next" :class="!switchQuestionEnabled ? 'clickDisable' : ''"
            :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow};`"
            @click="switchQuestionEnabled ? changeQuestion('nextQuestion') : null" v-show="!isLast">下一题</a>
          <a class="next" :class="!switchQuestionEnabled ? 'clickDisable' : ''"
            :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow}`"
            @click="switchQuestionEnabled ? submitPaper() : null" v-show="isLast">交卷</a>
        </div>
      </template>
    </div>

    <!-- 操作题全屏操作按钮 -->
    <div class="full-screen-btn" v-show="isFullScreen">
      <button type="button" class="btn" @click="openDetail" :style="openBtnStyle">
        查看题目
      </button>
      <button class="btn" @click="saveWork" :disabled="saving" :style="'background:' + theme.themeColor">
        保存作品
      </button>
      <button class="btn" @click="outFullScreen" :style="'background:' + theme.themeColor">
        退出全屏
      </button>
      <button class="reset-ques" @click="showResetTip = true" :style="'color:' + theme.themeColor">
        重置
      </button>
      <div class="question-detail" :class="{ show: showDetail }">
        <i class="icon-close" @click="openDetail"></i>
        <div class="content question-render-container"></div>
      </div>
    </div>

    <!-- 重置提示框 -->
    <modal width="450px" speed="fast" title="提示" noOutClose :show="showResetTip" enter-active-class="fadeIn"
      leave-active-class="fadeOut" @update:show="showResetTip = false">
      <div slot="content">
        <p style="font-size: 16px">
          重置操作将会清空所有修改恢复初始状态，是否继续？
        </p>
      </div>
      <div slot="footer">
        <button class="white-btn" @click="showResetTip = false">取消</button>
        <button class="blue-btn" @click="resetQues">确定</button>
      </div>
    </modal>

    <!--闯关题相关-->
    <modal width="410px" speed="fast" noHeader noFooter maskNoClick enter-active-class="fadeIn"
      leave-active-class="fadeOut" :show.sync="nextExploreVisible" class="next_explore_tip">
      <div slot="content">
        <i class="el-icon-success tip-icon"></i>
        <p class="tip-desc">
          闯关成功，用时{{ computeTime(exploreSuccessData.finishTime) }}
        </p>
        <p class="tip-result">
          <span class="tip-text">本次闯关使用积木：<span class="tip-text-bold">{{ exploreSuccessData.useBlockCount
              }}块</span></span>
          <span class="tip-text mr-20">最佳闯关使用积木：<span class="tip-text-bold">{{ exploreSuccessData.bestBlockCount
              }}块</span></span>
        </p>
        <div class="submit-btn-wrap">
          <button class="confirm" :style="`color: #666666 border: 1px solid #A1A1A1`" @click="exploreAginBtn">
            再闯本关
          </button>
          <div v-if="!isLast" class="tip-btn-next">
            <button class="continue" :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow}`"
              @click="exploreNextBtn">
              下一关
            </button>
            <span class="tip-text mt-10">
              <span class="tip-text-bold">5s</span>后自动跳到下一关
            </span>
          </div>
          <button v-else class="continue"
            :style="`background: ${theme.buttonBackground} box-shadow: ${theme.buttonShadow}`"
            @click="submitPaper()">
            提交答卷
          </button>
        </div>
      </div>
    </modal>
    <img v-show="exploreFailVisible" class="exploreFailStyle" :src="exploreFailImg" />
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { get } from '@/utils/ajax'
import Modal from '@/components/Modal'
import { formateQuesType } from '@/utils/common'
import QuestionContentMixin from '@/mixins/QuestionContentMixin'
import { downloadData } from '@/utils'
import { sdkUploader } from '@/utils/upload-sdk'
import Vue from 'vue/dist/vue'
import debounce from 'lodash/debounce'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import * as Sentry from '@sentry/browser'

// 操作题类型集合 0-kitten 2-python 3-scratch 5-explore 6-c++ 7-python_oj
const operateQuestionTypes = [0, 2, 3, 5, 6, 7]

export default {
  mixins: [QuestionContentMixin],
  components: {
    Modal,
    LoopingRhombusesSpinner
  },
  props: {
    questionList: {
      type: Array,
      default() {
        return []
      }
    },
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    isFirst: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    },
    switchQuestionEnabled: {
      type: Boolean,
      default: true
    },
    countdown: {
      type: Number
    },
    endTime: {
      type: Number
    }
  },
  filters: {
    // 页面倒计时
    formateTime(value, countdown) {
      const time = value - countdown
      return time
    },
    // 倒计时格式化
    timeFactory(timestamp) {
      timestamp = timestamp / 1000
      if (timestamp <= 0) {
        return '00 : 00 : 00'
      }
      let h = Math.floor(timestamp / 3600)
      let m = Math.floor((timestamp / 60) % 60)
      let s = Math.floor(timestamp % 60)
      h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return h + ' : ' + m + ' : ' + s
    }
  },
  data() {
    return {
      order: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      answerMap: {}, // 答题记录
      isFullScreen: false, // 全屏作答
      fullScreenLoading: false, // 全屏loading
      timer: null, // 自动保存定时器
      showResetTip: false, // 重置弹窗
      showDetail: false, // 题目详情弹窗
      openBtnStyle: {}, // 查看题目按钮样式
      operateIds: ['kitten', '', 'python', 'scratch', '', 'explore', 'cplusplus', 'python_oj'], // 工具类型，ID作为唯一键
      operateIniteds: [false, false, false, false, false, false, false, false], // 工具初始化状态，questionType 的值为索引
      isReset: false,

      // 闯关题相关
      nextExploreVisible: false, // 是否展示闯关通过模态框
      exploreSuccessData: {
        bestBlockCount: 0,
        codeStr: '',
        finishTime: 0,
        msg: '',
        useBlockCount: 0
      }, // 闯关成功数据
      exploreFailImg: 'https://education.codemao.cn/27/exam/1/exploreFail.png', // 失败图形
      exploreFailVisible: false,
      nextTimeout: null,
      failTimeout: null,
      isFull: false,

      // 加载、保存状态控制
      loading: false,
      saving: false,
      isFiveSecondsEnd: false // 还有5秒结束考试，进行一次操作题保存
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme
    },
    // 是否是操作题
    isOperateQuestion() {
      return operateQuestionTypes.includes(this.question.questionType)
    },
    // 是否是闯关题
    isExploreQuestion() {
      return this.question.questionType === 5
    }
  },
  watch: {
    question: {
      handler: function (val) {
        // 非闯关类型
        if (val.questionType !== 5) this.isFull = false
        if (val.answer) {
          // 初始化考生已答题目答案
          switch (val.typeId) {
            case 1:
            case 6:
              this.$set(this.answerMap, val.questionId, Number(val.answer))
              break
            case 2:
              const values = val.answer.map(el => Number(el))
              this.$set(this.answerMap, val.questionId, values)
              break
            default:
              this.$set(this.answerMap, val.questionId, val.answer)
          }
        }

        // 渲染题目
        this.renderRawDescription(val.rawDescription)
        this.$nextTick(() => {
          this.$refs.scrollBox.scrollTop = 0
          this.initIframe()
        })
      },
      deep: true,
      immediate: true
    },
    countdown(value) {
      const num = this.endTime - value
      if (this.endTime && !this.isFiveSecondsEnd && num <= 30000) {
        this.isFiveSecondsEnd = true
      }
    },
    // 还有五秒钟结束考试，如果正在全屏作答，则保存一次答案
    isFiveSecondsEnd(value) {
      if (value && this.isOperateQuestion && this.isFullScreen) {
        this.saveWork()
      }
    }
  },
  methods: {
    // 初始化操作题
    initIframe() {
      const { questionType } = this.question
      // 当前题目是操作题
      if (this.isOperateQuestion) {
        this.createIframe(questionType)
        this.hideIframe(questionType)
      }
    },
    // 创建操作题dom节点
    createIframe(questionType) {
      const id = this.operateIds[questionType]
      let url = ''
      switch (questionType) {
        case 0: // kitten
          url = `${CONFIG.ide}?in_edu_lesson=true`
          break
        case 2: // python
          url = CONFIG.python
          break
        case 3: // scratch
          url = `${CONFIG.scratch}?work_url=https://education.codemao.cn/27/exam/1/1598446666000/scratch_default.sb3`
          break
        case 5: // 闯关
          url = this.question.uploadUrl
          break
        case 6: // c++
          url = CONFIG.cplusplus
          break
        case 7: // python_oj
          url = CONFIG.python_oj
          break
      }
      const iframeWrap = document.querySelector('#iframeWrap')
      const hasIframe = iframeWrap.querySelector(`#${id}`) // 是否已存在该题型的iframe
      if (hasIframe) {
        // 直接加载当前题目内容
        this.loadWork()
      } else {
        this.loading = true
        // 创建新的Iframe
        // 创建构造器
        const Profile = Vue.extend({
          template:
            '<iframe :src="url" :id="id" width="100%" height="100%" class="if-common" allow="microphone;camera;midi;encrypted-media;accelerometer;gyroscope;"></iframe>',
          data: function () {
            return {
              url: url,
              id: id
            }
          }
        })
        // 创建 Profile 实例，并挂载
        iframeWrap.appendChild(new Profile().$mount().$el)
      }
    },
    // 隐藏iframe
    hideIframe(type) {
      const id = this.operateIds[type]
      const iframeWrap = document.querySelectorAll('.if-common')
      iframeWrap.forEach((item) => {
        item.style.display = item.id === id ? 'block' : 'none'
      })
    },
    // 下载考试资料
    downloadExamData(url) {
      downloadData(url)
    },
    // 打开上传选择
    uploadFile() {
      this.$refs.fileInput.click()
    },
    // 上传新题型答案到七牛云
    async fileChange(e) {
      const file = e.target.files[0]
      this.$refs.fileInput.value = ''

      try {
        const res = await sdkUploader(file)
        this.$set(this.answerMap, this.question.questionId, res.url)
        this.$message.success('上传成功！')
      } catch (e) {
        this.$message.error('上传失败，请重试！')
      }
    },
    setStateStyle(option) {
      let style = ''
      if (option.submit_id === this.answerMap[this.question.questionId]) {
        style = `border: 1px solid ${this.theme.themeColor}`
        return style
      }
      return `border: 1px solid ${this.theme.lightThemeColor}`
    },
    areaChange(e, useTheme) {
      if (useTheme) {
        e.target.style = `border-color: ${this.theme.themeColor}`
      } else {
        e.target.style = `border-color: ${this.theme.lightThemeColor}`
      }
    },
    styleChange(e, option, typeId, useTheme) {
      const answer = this.answerMap[this.question.questionId]
      if ((typeId === 1 || typeId === 6) && option.submit_id === answer) {
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: none; background-color: ${this.theme.themeColor}`
        return
      }
      if (typeId === 2 && answer && answer.includes(option.submit_id)) {
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: none; background-color: ${this.theme.themeColor}`
        return
      }
      if (useTheme) {
        e.target.style = `border: 1px solid ${this.theme.themeColor}`
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: 1px solid ${this.theme.themeColor}
        background-color: ${this.theme.lightThemeColor}`
      } else {
        e.target.style = ''
        e.target.querySelector(
          '.option-name-wrap'
        ).style = `border-right: none; background-color: ${this.theme.lightThemeColor}`
      }
    },
    // 全屏开启定时保存
    showFullScreen() {
      this.isFullScreen = true
      this.$emit('changeStyle', true)
      this.autoSave()
    },
    // 退出全屏关闭定时
    outFullScreen() {
      this.isFullScreen = false
      this.showDetail = false
      this.$emit('changeStyle', false)
      this.saveWork()
      clearInterval(this.timer)
    },
    // 单选题、多选题、判断题选择选项
    selectOption(id) {
      let answer = this.answerMap[this.question.questionId]
      // 多选题
      if (this.question.typeId === 2) {
        answer = answer instanceof Array ? answer.slice() : []
        if (answer.includes(id)) {
          answer.splice(answer.indexOf(id), 1)
        } else {
          answer.push(id)
        }
      } else {
        answer = id
      }
      this.$set(this.answerMap, this.question.questionId, answer)
    },
    // 重置操作题题目
    resetQues() {
      this.isReset = true
      this.showResetTip = false
      this.fullScreenLoading = true
      this.loadWork()
    },
    // 查看题目详情
    openDetail() {
      this.showDetail = !this.showDetail
      this.openBtnStyle = {
        background: this.showDetail
          ? '#fff'
          : `${this.theme.themeColor.split(';')[0]}`,
        color: this.showDetail
          ? `${this.theme.themeColor.split(';')[0]}`
          : '#fff',
        border: this.showDetail
          ? `1px solid ${this.theme.themeColor.split(';')[0]}`
          : 'none'
      }
    },
    formateType(id, questionType = 5) {
      return formateQuesType(id, questionType)
    },
    // 开始时禁止切题操作
    excuteExplore() {
      this.$emit('changeQuesEnabled', false)
    },
    // 停止时允许切题操作
    stopExplore() {
      this.$emit('changeQuesEnabled')
    },
    // 闯关数据存储
    saveExploreData(data) {
      this.$emit('saveExplore', {
        which: 'saveExplore',
        steps: data.useBlockCount,
        finishTime: data.finishTime,
        answer: { url: data.codeStr },
        currentId: this.question.questionId,
        successCallback: () => {
          this.stopExplore()
          this.exploreSuccessData = data
          this.nextExploreVisible = true
          if (!this.isLast) {
            this.nextTimeout = setTimeout(() => {
              this.nextExploreVisible = false // 先关闭模态框再执行下一关
              this.exploreNextBtn()
            }, 6000)
          }
        },
        failCallback: () => {
          this.stopExplore()
          this.exploreAginBtn()
        }
      })
    },
    // 再闯本关
    exploreAginBtn: debounce(
      function () {
        clearTimeout(this.nextTimeout)
        this.nextExploreVisible = false
        const explore = document.getElementById('explore')
        explore.contentWindow.postMessage(
          { msg: 'ExplorerRestart' },
          CONFIG.explorer
        )
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 下一关
    exploreNextBtn: debounce(
      function () {
        clearTimeout(this.nextTimeout)
        this.nextExploreVisible = false
        this.changeQuestion('nextQuestion')
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 闯关失败提示
    exploreFail() {
      clearTimeout(this.failTimeout)
      this.exploreFailVisible = true
      this.failTimeout = setTimeout(() => {
        this.stopExplore()
        this.exploreFailVisible = false
        this.exploreAginBtn()
      }, 3000)
    },
    // 计算用时
    computeTime(t) {
      const hasHour = Math.floor(t / 60)
      const h = hasHour / 60 > 1 ? `${hasHour}时` : ''
      const m = hasHour > 60 ? `${hasHour % 60}分` : `${hasHour}分`
      const s = `${t % 60}秒`
      return `${h}${m}${s}`
    },
    // 初始化Tart工具 type= 'py_oj' | 'cpp_oj'
    initTart(type) {
      let tart = null
      let domain = '*'
      let exportName = ''
      switch (type) {
        case 'py_oj':
          tart = document.getElementById('python_oj')
          domain = CONFIG.python_oj
          exportName = 'exportAsPythonFile'
          break
        case 'cpp_oj':
          tart = document.getElementById('cplusplus')
          domain = CONFIG.cplusplus
          exportName = 'exportAsCppFile'
          break
        default:
          throw new Error('未知编辑器')
      }

      if (!tart) return
      const tartWindow = tart.contentWindow

      tartWindow.postMessage(
        {
          type: 'FEATURE_SET_CONFIG',
          payload: {
            headerDisabled: false, // 默认展示头部栏，true 则隐藏
            headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
            headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
            headerFileMenuItems: [
              // 'createProject',
              // 'openProjectManager',
              // 'workSaveAs',
              // 'divider',
              // 'openLocalFile',
              exportName
              // 'divider',
              // 'importMiaoLink',
              // 'exportAsMiaoLink',
            ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
            userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
            workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
            workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
            disabledRegExp: true // 默认隐藏正则配置，false 则展示
          }
        },
        domain
      )
    },
    initKitten() {
      // 初始化kitten配置项
      const kitten = document.getElementById('kitten')
      if (!kitten) return
      const kittenWindow = kitten.contentWindow
      kittenWindow.postMessage(
        {
          type: 'kitten_set_ui',
          content: {
            header: {
              file: true, // 展示文件按钮
              export_file: true, // 展示保存作品到本地
              setting: true, // 展示设置按钮
              language: true, // 展示语言切换
              save: false // 隐藏保存按钮
            }
          }
        },
        CONFIG.ide
      )
    },
    initPython() {
      const python = document.getElementById('python')
      if (!python) return
      const pythonWindow = python.contentWindow
      // 设为代码模式
      pythonWindow.postMessage({ msg: 'set_default_mode', mode: 'code' }, CONFIG.python)
      // 隐藏切换积木模式按钮
      pythonWindow.postMessage({ msg: 'set_mode_btn_display', mode: 'false' }, CONFIG.python)
      // 隐藏自带的缩放按钮
      pythonWindow.postMessage({ msg: 'set_fullscreen_btn_display', is_display: false }, CONFIG.python)
      // 隐藏帮助按钮
      pythonWindow.postMessage({ msg: 'set_help_btn_display', is_display: false }, CONFIG.python)
      // 打开海龟绘图
      pythonWindow.postMessage({ msg: 'set_turtle_canvas_display', is_display: true }, CONFIG.python)
    },
    // 3分钟自动保存
    autoSave() {
      this.timer = setInterval(() => {
        this.saveWork()
      }, 180000)
    },
    // 加载作品
    async loadWork() {
      this.loading = true
      const { questionId, questionType } = this.question

      // 是否初始化完成
      const inited = this.operateIniteds[questionType]
      if (!inited) {
        return
      }

      const iframeId = this.operateIds[questionType]
      const iframe = document.getElementById(iframeId)
      if (!iframe) {
        return
      }
      const iframeWindow = iframe.contentWindow
      switch (questionType) {
        case 0: // kitten
          let bcmUrl = this.question.kitten.start_bcm.url
          const answer = this.answerMap[questionId]
          if (answer && !this.isReset) {
            if (typeof answer === 'string') {
              const { bcm_url } = await get(`/edu/exams/works/kitten?code=${answer}`)
              bcmUrl = bcm_url
            } else {
              bcmUrl = answer.url
            }
          }
          iframeWindow.postMessage({ type: 'load_bcm', content: bcmUrl }, CONFIG.ide)

          // 打开素材库
          if (this.question.kittenMaterialLoad === 1) {
            iframeWindow.postMessage({
              type: 'kitten_set_ui',
              content: { sprite_panel: { material_dialog: true } }
            }, CONFIG.ide)
          }
          break
        case 3: // scratch
          let sb3Url = this.question.uploadUrl
          if (this.answerMap[questionId] && !this.isReset) {
            sb3Url = this.answerMap[questionId]
          }
          iframeWindow.postMessage({ type: 'load_sb3', content: sb3Url }, CONFIG.scratch)
          break
        case 5: // explore
          iframe.src = this.question.uploadUrl
          break
        case 2: // python
        case 6: // c++
        case 7: // python_oj
          let code = this.question.operation.template_source_code
          if (this.answerMap[questionId] && !this.isReset) {
            code = this.answerMap[questionId]
          }
          if (questionType === 2) { // python
            iframeWindow.postMessage({ msg: 'set_python_code', code: code }, CONFIG.python)
          } else { // c++ 或 python_oj
            iframeWindow.postMessage({
              type: 'WORK_OPEN',
              payload: {
                work: {
                  work_id: 0,
                  name: '新的作品',
                  extension: questionType === 6 ? 'cpp' : 'py',
                  content: code,
                  version: 0
                }
              }
            }, questionType === 6 ? CONFIG.cplusplus : CONFIG.python_oj)
          }
          this.loading = false
          if (this.isReset) {
            this.isReset = false
            this.fullScreenLoading = false
            this.$message.success('重置成功！')
          }
          break
      }
    },
    // 通知工具保存
    saveWork() {
      this.saving = true
      if (!this.isFullScreen) {
        this.$emit('showSaveLoading')
      }
      const questionType = this.question.questionType
      const id = this.operateIds[questionType]
      const iframe = document.getElementById(id)
      if (!iframe) {
        this.saving = false
        return
      }
      const iframeWindow = iframe.contentWindow
      switch (questionType) {
        case 0: // kitten
        case 3: // scratch
          iframeWindow.postMessage({
            type: 'save_work_by_ticket',
            content: {
              x_ticket: window.sessionStorage.getItem('QINIUTOKEN'),
              question_id: this.question.questionId
            }
          }, questionType === 0 ? CONFIG.ide : CONFIG.scratch)
          break
        case 2: // python
          iframeWindow.postMessage({ msg: 'get_python_code' }, CONFIG.python)
          break
        case 6: // c++
        case 7: // python_oj
          iframeWindow.postMessage({ type: 'WORK_GET_CURRENT_DATA' }, questionType === 6 ? CONFIG.cplusplus : CONFIG.python_oj)
          break
        default:
          this.$message.error('未知操作题')
          break
      }
    },
    changeQuestion(which) {
      // 如果不是操作题，做保存动作
      if (!this.isOperateQuestion) {
        this.saveAnswer('saveQuestion')
      }
      this.$emit('changeQuestion', {
        which,
        currentId: this.question.questionId
      })
    },
    // 保存答案
    saveAnswer(which, data) {
      const { questionId, ...rest } = (data || {})
      const currentId = questionId || this.question.questionId
      const answer = this.answerMap[currentId]
      this.$emit('saveAnswer', {
        which,
        answer,
        currentId,
        ...rest
      })
    },
    // 交卷
    submitPaper() {
      this.$emit('submitPaper')
    },
    // 操作题接收 postMessage 消息
    iframeMessage(e) {
      const questionType = this.question.questionType
      const message = e.data
      switch (message.type) {
        case 'exam_save_end': // kitten/scratch 保存作品结果
          if (message.content.content.status === 'error') {
            this.saving = false
            if (message.content.content.error_type === 'token_expired') {
              this.$message.error('登录态失效，请重新登录')
              this.$emit('showLoginDialog')
            } else {
              this.$message.error('保存作品失败，请重新保存')
            }
            Sentry.captureEvent({
              message: '作品保存失败',
              extra: message.content
            })
          } else {
            const url = message.content.content.bcm_url ||
              message.content.content.sb3_url

            if (!url) {
              this.saving = false
              this.$message.error('保存作品失败，请重新保存')
              Sentry.captureEvent({
                message: '作品保存成功，但没有返回作品链接',
                extra: message.content
              })
              return
            }

            const questionId = message.content.content.question_id
            this.$set(this.answerMap, questionId, { url })
            if (message.platform === 'scratch') {
              this.saveAnswer('saveScratch', {
                questionId,
                successCallback: () => {
                  this.saving = false
                },
                failCallback: () => {
                  this.saving = false
                }
              })
            } else {
              this.saveAnswer('saveKitten', {
                questionId,
                successCallback: () => {
                  this.saving = false
                },
                failCallback: () => {
                  this.saving = false
                }
              })
            }
          }
          break
        case 'exam_login_fail':
          this.loading = false
          this.saving = false
          this.$message.error('登录态失效，请重新登录')
          this.$emit('showLoginDialog')
          break
        case 'scratch_loaded': // scratch工具初始化完成
          this.operateIniteds[3] = true
          if (questionType === 3) {
            this.loadWork()
          }
          break
        case 'exam_load_bcm_end': // 加载bcm的结果
          this.loading = false
          if (message.content.content.status === 'error') {
            this.$emit('openSlowTip', 'loadQues')
            return
          }

          if (this.isReset) {
            this.isReset = false
            this.fullScreenLoading = false
            this.$message.success('重置成功！')
          }
          break
        case 'exam_load_sb3_end': // 加载sb3的结果
          this.loading = false
          if (message.content.content.status === 'error') {
            this.$emit('openSlowTip', 'loadQues')
            return
          }
          if (this.isReset) {
            this.isReset = false
            this.fullScreenLoading = false
            this.$message.success('重置成功！')
          }
          break
        case 'IFRAME_READY': // c++、python_oj工具初始化完成
          this.operateIniteds[message.payload.page === 'cpp_oj' ? 6 : 7] = true
          this.initTart(message.payload.page)
          if ([6, 7].includes(questionType)) {
            this.loadWork()
          }
          break
        case 'WORK_CURRENT_DATA': // c++、python_oj获取作品成功
          this.saving = false
          this.$set(this.answerMap, this.question.questionId, message.payload.work.content)
          if (this.question.questionType === 6) {
            this.saveAnswer('saveCplusplus')
          } else if (this.question.questionType === 7) {
            this.saveAnswer('savePythonOj')
          }
          break
        case 'WORK_GET_CURRENT_DATA_FAILED': // c++、python_oj获取作品失败
          this.saving = false
          this.$message.error('保存作品失败，请重新保存')
          Sentry.captureEvent({
            message: '作品保存失败',
            extra: message.payload
          })
          break
      }
      switch (message.msg) {
        case 'wood_is_ready': // python初始化完成
          this.operateIniteds[2] = true
          this.initPython()
          if (questionType === 2) {
            this.loadWork()
          }
          break
        case 'python_code': // python获取作品成功
          this.saving = false
          this.$set(this.answerMap, this.question.questionId, message.code)
          this.saveAnswer('savePython')
          break
        case 'ExplorerStopExecute':
          this.stopExplore()
          break
        case 'ExplorerStartExecute':
          this.excuteExplore()
          break
        case 'ExplorerInit':
          this.operateIniteds[5] = true
          this.loading = false
          break
        case 'ExplorerTaskSuccess':
          this.saveExploreData(message)
          break
        case 'ExplorerTaskFail':
          this.exploreFail()
          break
      }
      switch (message.content) {
        case 'kitten_is_ready': // kitten初始化完成并且空白作品加载完成后才能去加载预置作品
          this.operateIniteds[0] = true
          this.initKitten()
          if (questionType === 0) {
            this.loadWork()
          }
          break
      }
    }
  },
  created() {
    // 保存题目答题
    eventBus.$on('saveQuestion', (id) => {
      const answer = this.answerMap[id]
      if (answer) {
        this.$emit('saveAnswer', {
          which: 'saveQuestion',
          answer,
          currentId: id
        })
      }
    })
  },
  mounted() {
    this.openBtnStyle = {
      background: `${this.theme.themeColor.split(';')[0]}`,
      color: '#fff',
      border: 'none'
    }
    window.addEventListener('message', this.iframeMessage)
  },
  destroyed() {
    clearInterval(this.timer)
    window.removeEventListener('message', this.iframeMessage)
  }
}
</script>
<style>
.el-image-viewer__mask {
  cursor: pointer;
}

.el-image-viewer__close {
  top: 80px;
  width: 48px;
  height: 48px;
  background: rgba(0, 0, 0, 0.4);
}

.el-icon-circle-close::before {
  content: "\e6db";
  color: #fff;
  font-size: 24px;
  line-height: 48px;
  font-weight: bold;
}

.el-popover {
  z-index: 2 !important;
}
</style>
<style lang="scss" scoped>
@keyframes loadingCircle {
  100% {
    transform: rotate((360deg));
  }
}

.exploreFailStyle {
  position: absolute;
  z-index: 999;
  width: 550px;
  transform: translate(50%, 10%);
}

.next_explore_tip {
  /deep/ .modal-head {
    border-bottom: none;
  }

  .tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    color: #333;
    font-size: 20px;
    font-weight: 500;
  }

  .tip-icon {
    color: #23be80;
    font-size: 49px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-right {
    display: inline-block;
    width: 11px;
    height: 9px;
    opacity: 1;
  }

  .icon-sigh {
    display: inline-block;
    width: 5px;
    height: 16px;
    opacity: 1;
  }

  .big-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 10px;
  }

  .small-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    opacity: 1;
  }

  .tip-desc {
    font-size: 18px;
    color: #333;
    font-weight: 500;
    color: #333333;
    line-height: 25px;
    text-align: center;
    margin: 15px 0;
  }

  .tip-result {
    display: flex;
    margin-bottom: 40px;
    justify-content: center;
  }

  .tip-text {
    font-size: 14px;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 20px;
  }

  .tip-text-bold {
    color: #000000;
  }

  .mr-20 {
    margin-left: 20px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .tip-btn-next {
    display: flex;
    flex-direction: column;
    align-items: end;
  }

  .submit-btn-wrap {
    width: 100%;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;

    .continue {
      @include theme-fill-btn(140px, 42px, 14px, 4px);
      margin-left: 20px;
    }

    .confirm {
      @include theme-empty-btn(140px, 42px, 14px, 4px);
    }
  }

  .left-btn-wrap {
    width: 100%;
    text-align: center;

    .confirm {
      @include theme-fill-btn(96px, 36px, 14px, 4px);
    }
  }
}

.question-content {
  height: 100%;
  flex: 1;
  display: flex;

  .scroll-box {
    position: relative;
    height: calc(100% - 120px);
    padding-top: 20px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 10px;
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #666;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #f7f7f7;
    }
  }

  .scroll-box-passcode {
    position: relative;
    height: calc(100% - 120px);
    padding: 10px;
    border: 1px solid #b9d7ff;
    border-radius: 8px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 10px;
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #666;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #f7f7f7;
    }
  }

  .question-wrap {
    position: relative;
  }

  .question-wrap-passcode {
    height: 100%;
    min-height: 340px;
  }

  .btn-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 1px solid #f2f7ff;
    height: 82px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 5;

    .next-tooltip {
      display: flex;
    }

    .next {
      @include theme-fill-btn(160px, 42px, 16px, 4px);
    }

    .prev {
      margin-right: 20px;
      @include theme-empty-btn(160px, 42px, 16px, 4px);
    }

    .clickDisable {
      color: #999999 !important;
      background: #f7f7f7 !important;
      border: 1px solid #d0d0d0 !important;
      cursor: not-allowed !important;
      box-shadow: none !important;
    }
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: $themeColor;
    border-color: $themeColor;
  }

  /deep/ .el-radio__input.is-checked+.el-radio__label {
    color: $themeColor;
  }

  /deep/ .el-radio__input+.el-radio__label {
    color: #333;
    font-weight: 400;
  }

  /deep/ .el-radio__inner:hover {
    border-color: $themeColor;
  }
}

.main-content {
  height: 100%;
  flex: 1;
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0 0;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.explore-title-tip {
  font-size: 12px;
  font-weight: 400;
  color: #8c8c8c;
  line-height: 17px;
}

.inner-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  margin-bottom: 10px;

  .type-name {
    width: 50%;
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 500;
    color: #333;
    line-height: 32px;

    .score {
      color: #666;
      font-weight: 400;
    }
  }

  .submit-btn {
    width: 136px;
    height: 44px;
    border-radius: 21px;
    background: linear-gradient(270deg,
        rgba(255, 167, 33, 1) 0%,
        rgba(255, 202, 33, 1) 100%);
    box-shadow: 0 6px 8px 0 rgba(255, 155, 0, 0.4);
    color: #fff;
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    .icon-submit {
      display: inline-block;
      width: 28px;
      height: 28px;
      background: url("~@/assets/images/icon-submit.png") center / cover no-repeat;
      margin-right: 5px;
      margin-top: 2px;
    }
  }
}

.question-desc {
  margin-bottom: 30px;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.5px;
  max-width: 960px;

  /deep/ img {
    max-width: 100%;
    max-height: 360px;
    width: auto;
    height: auto;
  }
}

.blank-wrap {
  margin-bottom: 30px;

  .blank-fill {
    width: 480px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 10px 20px;
    line-height: 22px;
    font-size: 16px;
    resize: none;
    min-height: 44px;
    word-break: break-all;

    &:focus,
    &:hover {
      border-color: $themeColor;
    }

    &::placeholder {
      font-size: 16px;
      color: #bbb;
    }
  }
}

.tool-wrap-passcode {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.tool-wrap {
  width: 500px;
  height: 333px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.editor {
  width: 100%;
  height: 100%;

  // transition: all 0.4s linear;
  &.full-screen {
    width: calc(100% - 100px);
    position: fixed;
    top: 0;
    left: 0;
    // bottom: 0;
    // right: 98px;
    z-index: 3;
  }
}

.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.toAnswer {
  width: 100%;
  line-height: 33px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 24px;
  font-weight: 300;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);

  .arrow {
    width: 23px;
    height: 18px;
    background: url("~images/full_screen_arrow@2x.png") no-repeat center / cover;
    margin-left: 10px;
  }
}

.full-screen-btn {
  width: 100px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -100px;
  position: relative;

  button {
    flex-shrink: 0;
    position: relative;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    padding: 8px 14px;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 15px;

    &:hover {
      font-size: 16px;
      padding: 8px 12px;
    }

    &:disabled {
      &:hover {
        font-size: 14px;
      }

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #fff, $alpha: 0.5) url(~@/assets/images/detect/mb-outer-loading.png) no-repeat 50% 50% / 50% auto;
        border-radius: 50%;
        cursor: default;
        animation: loadingCircle 1s infinite linear;
      }
    }
  }

  .btn {
    color: #fff;
    // background: #397EFD;
  }

  .open-btn {
    background: #fff;
    color: $themeColor;
    border: 1px solid $themeColor;
    padding: 8px 14px;
  }

  .question-detail {
    position: absolute;
    right: 100px;
    top: 57px;
    bottom: 40px;
    width: 0;
    height: calc(100% - 100px);
    background-color: #fff;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    transition: width ease 0.3s;

    &.show {
      width: 612px;
      padding: 20px 20px 80px 20px;

      .icon-close {
        display: inline-block;
      }
    }

    .icon-close {
      display: none;
      width: 16px;
      height: 16px;
      background: url("~@/assets/images/icon-black-close.png") center / cover no-repeat;
      float: right;
      cursor: pointer;
    }

    .content {
      margin-top: 40px;
      font-size: 18px;
      color: $titleColor;
      line-height: 27px;
      overflow: scroll;
      height: 100%;

      /deep/ img {
        max-width: 100%;
      }
    }
  }

  .reset-ques {
    font-size: 14px;
    color: #397efd;
    margin-top: 40px;
    background-color: #fff;
  }
}

.new-type-wrap {
  .upload-wrap {
    width: 100%;
    padding: 30px 0 30px 13px;
    color: #111;
    font-size: 16px;
    background-color: #fafafa;

    .tip {
      margin-bottom: 20px;
    }

    .answer-wrap {
      padding: 5px 0 0 75px;
      height: 55px;
      position: relative;
      display: flex;

      .python-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 55px;
        height: 55px;
        background: url("~images/python-icon.png") center / cover no-repeat;
      }

      .answer-info {
        width: 256px;
        color: #333;
        font-size: 16px;
        line-height: 25px;

        .file-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .upload-time {
          color: #999;
          font-size: 14px;
        }
      }

      .change-btn {
        line-height: 25px;
        font-size: 16px;
        color: #377dfd;
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }

  .data-upload,
  .data-download {
    display: flex;
    align-items: center;
    height: 42px;
    padding: 0 30px;
    border: 1px solid #397efd;
    border-radius: 4px;
    color: #397efd;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    background-color: #fff;

    .download-icon,
    .upload-icon {
      display: inline-block;
      width: 19px;
      height: 18px;
      background: url("~images/nct-download.png") no-repeat center / cover;
      margin-right: 9px;
    }

    .upload-icon {
      background: url("~images/nct-upload.png") no-repeat center / cover;
    }
  }

  .data-download {
    margin: 0 0 25px 13px;
  }
}

.option-wrap {
  display: inline-block;

  .option {
    display: flex;
    border-radius: 8px;
    border: 1px solid #efefef;
    margin-bottom: 20px;
    cursor: pointer;
    overflow: hidden;
    padding-right: 15px;
    min-width: 480px;
    max-width: 70%;

    .option-name-wrap {
      flex: 0 0 35px;
      background-color: #f5f9ff;
      margin-right: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .option-content {
      display: flex;
      flex-direction: column;
      padding: 18px 0;

      .desc {
        width: 100%;
      }

      .image {
        max-width: 100%;
        display: block;
        border-radius: 4px;
      }
    }

    &:hover {
      border: 1px solid $themeColor;

      .option-name-wrap {
        border-right: 1px solid $themeColor;
      }
    }

    &.is-select {
      border: 1px solid $themeColor;

      .option-name-wrap {
        background-color: $themeColor;
        color: #fff;
      }
    }
  }
}

.white-btn {
  @include cancel-btn(96px, 36px, 14px, 4px);
  margin-right: 20px;
  margin-bottom: 10px;
}

.blue-btn {
  @include theme-fill-btn(96px, 36px, 14px, 4px);
}

.countdown {
  position: fixed;
  top: 8px;
  right: 120px;
  z-index: 3;
  color: #ac6f29;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(172, 111, 41, 0.25);
  border-radius: 45px;
  width: 242px;
  height: 36px;

  .word {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(172, 111, 41, 1);
  }

  .time {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(172, 111, 41, 1);
    margin-left: 8px;
  }
}

.py-countdown {
  top: 6px;
  height: 28px;
}

.scratch-countdown {
  top: 6px;
  background: rgba(0, 62, 175, 0.25);

  .word {
    color: rgba(255, 255, 255, 1);
  }

  .time {
    color: rgba(255, 255, 255, 1);
  }
}

.tart-countdown {
  background: rgba(0, 0, 0, 0.25);

  .word {
    color: #fff;
  }

  .time {
    color: #fff;
  }
}

.full-screen-position {
  right: 50%;
  transform: translateX(50%);
}

.fadeInRight {
  animation-name: fadeInRight;
  animation-duration: 0.5s;
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
  }
}

.fadeOutRight {
  animation-name: fadeOutRight;
  animation-duration: 0.5s;
}

@keyframes fadeOutRight {
  0% {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}

.loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
}

.box-full-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}

.box-full-screen-content {
  height: calc(100% - 40px) !important;
}

.box-full-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: contain;
  }

  .close {
    background-image: url(../../../assets/images/icon_close-full.png);
  }

  .full {
    background-image: url(../../../assets/images/icon_full.png);
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    margin-left: 7px;
  }

  &:hover {
    span {
      color: #387efd;
    }

    .close {
      background-image: url(../../../assets/images/icon_close-full_b.png);
    }

    .full {
      background-image: url(../../../assets/images/icon_full_b.png);
    }
  }
}
</style>
